import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const PhotoSlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    arrows: true,
  };

  const images = [
    '/images/showroom/showroom1.jpg',
    '/images/showroom/showroom2.jpg',
    '/images/showroom/showroom3.jpg',
    '/images/showroom/showroom4.jpg'
  ];

  return (
    <div className="relative h-screen w-full">
      <Slider {...settings}>
        {images.map((img, index) => (
          <div key={index} className="h-screen">
            <img 
              src={img} 
              alt={`Slide ${index}`} 
              className="w-full h-full object-cover" 
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default PhotoSlider;
